<ng-container *ngIf="entity">
	<a *ngIf="canShow()" [routerLink]="link()" class="table-link">{{ title() }}</a>
	<span *ngIf="!canShow()">{{ title() }}</span>
</ng-container>
